import { gql } from '@apollo/client';
const TENANT_TEMPLATE = gql `
  fragment TenantTemplateFragment on ModelSpecificationTemplateNode {
    id
    name
    templateElements {
      edges {
        node {
          id
          element {
            id
            name
          }
        }
      }
    }
  }
`;
export default TENANT_TEMPLATE;
